import Box from "@mui/material/Box";
import Header from "@/app/components/header";
import Footer from "@/app/components/footer";
import { HomeLayoutHelmet } from "@/app/(public)/_seo/PublicLayoutMetadata";
import HeroSection from "./HeroSection";
import RotatingLogoMarquee from "./RotatingLogoMarquee";
import FeatureCardsSection from "./FeatureCardsSection";
import PressLogosRow from "./PressLogosRow";
import WhatTheyreSaying from "./WhatTheyreSaying";

export default function Home() {
  return (
    <>
      <HomeLayoutHelmet />
    <Box sx={{ width: "100%", maxWidth: "100vw", overflowX: "hidden", boxSizing: "border-box" }}>
      <Header variant="dark" />
      <Box component="main">
      <HeroSection />
      <Box
        component="section"
        aria-label="Trusted by leading brands"
        sx={{ position: "relative", zIndex: 2, mt: { xs: 0, md: -10 } }}
      >
        <RotatingLogoMarquee />
      </Box>
      <FeatureCardsSection />
      <Box
        component="section"
        aria-label="Press and quotes"
        sx={{ backgroundColor: "#ffffff" }}
      >
        <WhatTheyreSaying />
        <PressLogosRow />
      </Box>
      </Box>
      <Footer variant="dark" />
    </Box>
    </>
  );
}
